import React from 'react';
import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { ZoomVideoError } from './useZoomVideo/useZoomVideo';
import { getMediaErrorTranslationId } from '../../utils/mediaErrorMessages';

const useStyles = makeStyles({
  container: {
    height: '100%',
    textAlign: 'center' as const,
  },
  message: {
    fontWeight: 'bold',
    fontSize: '16px',
    marginTop: 16,
  },
  retryButton: {
    marginTop: 16,
  },
});

interface ZoomConnectingScreenProps {
  error: ZoomVideoError | null;
  retryExhausted: boolean;
  onRetry: () => void;
}

export default function ZoomConnectingScreen({ error, retryExhausted, onRetry }: ZoomConnectingScreenProps) {
  const classes = useStyles();
  const intl = useIntl();

  if (error && retryExhausted) {
    return (
      <Grid container justifyContent="center" alignItems="center" direction="column" className={classes.container}>
        <Typography className={classes.message}>
          {intl.formatMessage({ id: 'zoom.error.contact_agent' })}
        </Typography>
      </Grid>
    );
  }

  if (error) {
    const messageId = getMediaErrorTranslationId(error.type, error.device);
    return (
      <Grid container justifyContent="center" alignItems="center" direction="column" className={classes.container}>
        <Typography className={classes.message}>
          {intl.formatMessage({ id: messageId })}
        </Typography>
        <Button
          className={classes.retryButton}
          variant="contained"
          color="primary"
          onClick={onRetry}
        >
          {intl.formatMessage({ id: 'zoom.error.retry' })}
        </Button>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center" alignItems="center" direction="column" className={classes.container}>
      <div>
        <CircularProgress variant="indeterminate" />
      </div>
      <Typography className={classes.message}>
        {intl.formatMessage({ id: 'zoom.connecting' })}
      </Typography>
    </Grid>
  );
}
